const TENANT_REGEX = /^[A-Fa-f0-9]{6}$/;

export function getTenantFromPath(path: string): string | null {
  const seg = path?.split('/').filter(Boolean)[0];
  const clean = seg?.split(/[?#]/)[0] ?? '';
  return TENANT_REGEX.test(clean ?? '') ? clean : null;
}
